import { Transmission } from "../data/bruktbilsalgBackend/types/car.types";

export const translateTransmission = (transmission: Transmission) => {
  switch (transmission) {
    case "Automatic":
      return "Automatisk";
    case "Manual":
      return "Manuell";
  }
};
